export enum GridMutationTypes {
    SET_GRIDS = 'SET_GRIDS',
}
